import * as Yup from 'yup';
import { PHONE_MASK } from '../..';
import { getI18nErrorMessage } from '../../i18n';

export const PHONE_NUMBER_VALIDATION_SCHEMA = Yup.string().length(
  PHONE_MASK.replace(/(\d+)[^\d]*/g, '$1').length,
  ({ length }) => getI18nErrorMessage('core.error.phone.length', { length })
);
